import React, { createContext, useContext, useState, useMemo, ReactNode, useEffect } from "react";
import { sequenceNumber } from "../revampCRUD/ticketsNforms.crud";

const SequenceNumberContext = createContext({
    sequenceNumberDetails: [],
    sequenceNumberLoading: false,
    sequenceNumberError: false,
    setSequenceNumberDetails: () => { },
    setSequenceNumberLoading: () => { },
    setSequenceNumberError: () => { },

});

// Define props that include children for UserProvider


const SequenceNumberProvider = ({ children }) => {

    const [sequenceNumberDetails, setSequenceNumberDetails] = useState([]);
    const [sequenceNumberLoading, setSequenceNumberLoading] = useState(false);
    const [sequenceNumberError, setSequenceNumberError] = useState(false);



    const getSequenceNumber = async (eventId) => {
        try {
            setSequenceNumberLoading(true)
            setSequenceNumberError(false)
            if (!eventId) {
                throw new Error("event id is not available")

            }
            const res = await sequenceNumber(eventId);
            setSequenceNumberDetails(res.data.sequence_number_details)
        } catch {
            setSequenceNumberDetails([])
            setSequenceNumberError(true)
        } finally {
            setSequenceNumberLoading(false)
        }

    }

    const value = useMemo(
        () => ({
            sequenceNumberDetails,
            sequenceNumberError,
            sequenceNumberLoading,
            setSequenceNumberDetails,
            setSequenceNumberError,
            setSequenceNumberLoading

        }),
        [sequenceNumberDetails, sequenceNumberError, sequenceNumberLoading]
    );

    return <SequenceNumberContext.Provider value={{ ...value, getSequenceNumber }}>{children}</SequenceNumberContext.Provider>;
};

// Hook to use the Event context
const useSequenceNumber = () => {
    const context = useContext(SequenceNumberContext);
    if (!context) {
        throw new Error("useSequenceNumber must be used within an SequenceNumberProvider");
    }
    return context;
};

export { SequenceNumberProvider, useSequenceNumber };
